import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { HubPlace } from '../../../../models/hub/hub.place';
import { ImageService } from '../../../../services/image.service';
import { PlaceDetailsModalComponent } from 'components/visitor/place.details.modal/place.details.modal.component';
import { PlaceDetailsModalActions } from '../../place.details.modal/place.details.modal.provider';
import { TripDetailModalActions, TripDetailModalData } from '../../trip/trip.detail.modal/trip.detail.modal.provider';
import { TripDetailModalComponent } from '../../trip/trip.detail.modal/trip.detail.modal.component';
import { EditorChoiceDataSource } from '../../../../models/hub/hub.event';
import { EditorChoiceStore } from '../../../../stores/hub.calendar.store';
import { PlaceService } from '../../../../services/place.service';

@Component({
  selector: 'ig-visitor-place-card',
  templateUrl: './visitor.place.card.component.html',
  styleUrls: ['./visitor.place.card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorPlaceCardComponent extends BaseComponent implements OnInit {
  @Input() public place: HubPlace;

  public hubName: string;
  public editorChoiceText = '';

  constructor(
    private router: Router,
    public imageService: ImageService,
    public modalService: ModalService,
    public editorChoiceStore: EditorChoiceStore,
    private activatedRoute: ActivatedRoute
  ) {
    super({activatedRoute});
  }

  public ngOnInit() {
    let {hubName} = this.allRouteParams;
    this.hubName = hubName;
    this.editorChoiceTextHandler();
  }

  public showReadable(code: string) {
    return PlaceService.allToReadableCategory(code);
  }

  public editorChoiceTextHandler() {
    this.editorChoiceStore.infoCommand.takeUntil(this.isDestroyed).subscribe((editorChoice: EditorChoiceDataSource) => {
      this.editorChoiceText = editorChoice.editorChoiceForPlace;
    });
  }

  public enterItemByKeyboard($event) {
    if ($event && $event.key === 'Enter') {
      this.showDetails();
    }
  }

  public showDetails() {
    if (this.place.isPromotionImage) {
      window.open(this.place.promotionLink, '_blank');
      return;
    }

    if (!this.isMobile) {
      let actions = <PlaceDetailsModalActions>{
        confirm: (event: ButtonTriggerEvent, data: any) => {
        },
      };

      this.modalService.show({
        component: PlaceDetailsModalComponent,
        providers: [
          {provide: PlaceDetailsModalActions, useValue: actions},
          {provide: HubPlace, useValue: this.place},
        ],
        panelClass: 'modal-fixed-top',
      });
    } else {
      this.showDetailModalForMobile(this.place, 'place');
      //     let {hubName, category, menuType} = this.allRouteParams;
      //     category = PlaceCategory.getPlaceCategoryKey(category);
      //     this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeDetails,
      //         {
      //             hubName,
      //             placeId: this.place._id,
      //             category: category,
      //             menuType: menuType
      //         }), { skipLocationChange: this.noChangeUrlWhenRedirect });
    }
  }

  public showDetailModalForMobile(item: any, displayingOn: string, isShowAddToTripBtn = false, index?: number) {
    let actions = <TripDetailModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
      },
    };
    this.modalService.show({
      component: TripDetailModalComponent,
      providers: [
        {provide: TripDetailModalActions, useValue: actions},
        {
          provide: TripDetailModalData,
          useValue: new TripDetailModalData(item, displayingOn, this.hubName, null, null, isShowAddToTripBtn, index),
        },
      ],
      panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
    });
  }

  public remove() {
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/place.card/visitor.place.card.component.ts